<div class="agu-drawer__scrim" [class.agu-drawer__scrim--open]="Open" (click)="Close()" aria-hidden="true"></div>
<div #panel class="agu-drawer" [class.agu-drawer--open]="Open" role="dialog" aria-modal="true" aria-label="Menu" tabindex="-1" [attr.inert]="Open ? null : ''" [attr.aria-hidden]="Open ? null : 'true'">
    <!-- `.mdclose` (P/Member_Hub.html:522, 886). -->
    <button #closeButton type="button" class="agu-drawer__close" aria-label="Close menu" (click)="Close()"><span aria-hidden="true">✕</span></button>
    <!-- The sidebar's `.prof`, cloned (P/Member_Hub.html:887-888). -->
    @if (Identity) {
        <div class="agu-drawer__identity">
            @if (Identity.ProfileLinkLabel) {
                <button type="button" class="agu-drawer__prof-ring" aria-label="Open my hub profile" (click)="RequestProfile()">
                    <span class="agu-drawer__avatar" aria-hidden="true"><span class="agu-drawer__avatar-inner">{{ Identity.Initials }}</span></span>
                </button>
            } @else {
                <span class="agu-drawer__avatar" aria-hidden="true"><span class="agu-drawer__avatar-inner">{{ Identity.Initials }}</span></span>
            }
            <span class="agu-drawer__name">{{ Identity.Name }}</span>
            @if (Identity.RoleLine) { <span class="agu-drawer__role">{{ Identity.RoleLine }}</span> }
            @if (Identity.ProfileLinkLabel) { <button type="button" class="agu-drawer__profile-link" (click)="RequestProfile()">{{ Identity.ProfileLinkLabel }}</button> }
        </div>
    }
    <!-- The sidebar's `.menu`, cloned (P/Member_Hub.html:887-889), with its tones (:1887-1907). -->
    <ul class="agu-drawer__menu" role="list" aria-label="Sections">
        @for (module of VisibleModules; track module.Key) {
            <li [attr.data-tone]="ToneOf(module)">
                <button type="button" class="agu-drawer__link" [class.agu-drawer__link--active]="IsActive(module)" [attr.aria-current]="IsActive(module) ? 'page' : null" (click)="Select(module)">
                    @if (module.IconName) {
                        <agu-icon [Name]="module.IconName" [Size]="19" [Solid]="IsActive(module)" />
                    } @else {
                        <i [class]="module.Icon" aria-hidden="true"></i>
                    }
                    <span>{{ LabelOf(module) }}</span>
                </button>
            </li>
        }
    </ul>
    <div class="agu-drawer__account">
        @if (CanReturnToHost) {
            <button type="button" class="agu-drawer__link" (click)="ReturnToHostRequested.emit()"><i class="fa-solid fa-arrow-left" aria-hidden="true"></i><span>Back to Explorer</span></button>
        }
        <button type="button" class="agu-drawer__link" (click)="SignOutRequested.emit()"><i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i><span>Sign out</span></button>
    </div>
</div>
